module.exports = __webpack_public_path__ + "static/img/1.d94ecef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/1.png
// module id = te8m
// module chunks = 0